class ResponseHandler {
    static handleResponse(response) {
        if (!response.ok) {
            return response.json().then(body => Promise.reject(body));
        }
        return response.json();
    }
}

export default ResponseHandler;
